/* Font loading helpers shared by the Stickered builders.
   - stkFontIndexFetch: the font list is kept in localStorage for a day and
     returned instantly; a fresh copy is fetched in the background for next time.
   - stkLazyFont: a font-list tile gets its font as soon as it scrolls into view,
     and every listed font is also preloaded quietly in the background (16 at a
     time, in list order) a moment after the page loads, so the whole list is
     ready before it opens instead of filling in one by one. The preload is
     skipped on Data Saver / 2G, where tiles still load as they scroll in. */
(function(){
  if (window.stkFontIndexFetch) return;
  var KEY = 'stk-font-index-v1';
  var TTL = 24 * 60 * 60 * 1000;
  function fresh(url) {
    return fetch(url).then(function(res){
      if (!res.ok) return res;
      return res.clone().text().then(function(text){
        try { localStorage.setItem(KEY, JSON.stringify({ url: url, at: Date.now(), text: text })); } catch (e) {}
        return res;
      });
    });
  }
  window.stkFontIndexFetch = function(url) {
    var cached = null;
    try { cached = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) {}
    if (cached && cached.url === url && cached.text && Date.now() - cached.at < TTL) {
      fresh(url).catch(function(){});
      return Promise.resolve(new Response(cached.text, { status: 200, headers: { 'Content-Type': 'application/json' } }));
    }
    return fresh(url);
  };

  var queue = [], queued = {}, active = 0, LIMIT = 16, scheduled = false, warming = false;
  function slowConnection() {
    var c = navigator.connection;
    return !!(c && (c.saveData || /2g/.test(c.effectiveType || '')));
  }
  function pump() {
    while (warming && active < LIMIT && queue.length) {
      active++;
      document.fonts.load('16px ' + queue.shift()).catch(function(){}).then(function(){ active--; pump(); });
    }
  }
  function scheduleWarm() {
    if (scheduled || slowConnection() || !document.fonts || !document.fonts.load) return;
    scheduled = true;
    var go = function(){
      setTimeout(function(){
        (window.requestIdleCallback || function(f){ f(); })(function(){ warming = true; pump(); }, { timeout: 3000 });
      }, 1000);
    };
    if (document.readyState === 'complete') go(); else window.addEventListener('load', go);
  }

  var observer = 'IntersectionObserver' in window ? new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if (!entry.isIntersecting) return;
      entry.target.style.fontFamily = entry.target.getAttribute('data-stk-lazy-font');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '150px' }) : null;
  window.stkLazyFont = function(el, family) {
    if (!queued[family]) { queued[family] = true; queue.push(family); scheduleWarm(); pump(); }
    if (!observer) { el.style.fontFamily = family; return; }
    el.setAttribute('data-stk-lazy-font', family);
    observer.observe(el);
  };
})();

(function(){
  if (window.__stickeredShowPlatePreviewReady) return;
  window.__stickeredShowPlatePreviewReady = true;

  var fontsBase = 'https://lzakvswydjwhynzrwold.supabase.co/storage/v1/object/public/fonts';
  var fontsIndexUrl = 'https://flow.stickered.co.nz/api/public/fonts';
  var state = {
    input: null,
    previewRoot: null,
    textEl: null,
    fontRoot: null,
    fontButton: null,
    fontLabel: null,
    fontList: null,
    fontName: null,
    propFont: null,
    propText: null,
    currentFont: {
      name: 'Licenz',
      css: "'stk-show-plate-licenz', sans-serif",
      url: fontsBase + '/Licenz.ttf',
      format: 'truetype'
    },
    fontsBuilt: false,
    fonts: []
  };

  function findPlateInput() {
    var byName = document.querySelector(
      'input[name="properties[Plate Text]"]:not([type="hidden"]), textarea[name="properties[Plate Text]"], #text-box-3990308'
    );
    if (byName) return byName;

    // Easify's text-field option no longer renders a name/id attribute we can
    // select on, so fall back to matching its component class + label text.
    var candidates = document.querySelectorAll('.po-textField-input, [class*="po-textField-input"]');
    var fallback = null;
    var textFallback = null;
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      var fieldRoot = el.closest('[class*="po-field-root"]');
      var labelEl = fieldRoot && fieldRoot.querySelector('[class*="po-label-root"]');
      var labelText = labelEl ? labelEl.textContent : '';
      if (!fallback) fallback = el;
      if (labelText && /plate\s*text/i.test(labelText)) return el;
      if (!textFallback && labelText && /text/i.test(labelText)) textFallback = el;
    }
    return textFallback || fallback;
  }

  function getPreviewValue() {
    return state.input && state.input.value ? state.input.value.trim() : 'PREVIEW';
  }

  function setFontPreviewContent(target, value, fontName) {
    if (!target) return;
    target.textContent = '';

    var sample = document.createElement('span');
    sample.className = 'stk-show-plate-font-sample';
    sample.textContent = value;

    var name = document.createElement('span');
    name.className = 'stk-show-plate-font-option-name';
    name.textContent = ' (' + fontName + ')';
    name.style.fontFamily = 'Arial, sans-serif';
    name.style.fontSize = '10px';
    name.style.fontWeight = '700';
    name.style.letterSpacing = '.04em';
    name.style.color = '#777';
    name.style.verticalAlign = 'middle';
    name.style.textTransform = 'uppercase';

    target.appendChild(sample);
    target.appendChild(name);
  }

  function getFormId(root) {
    return (root && root.getAttribute('data-product-form')) ||
      (state.input && state.input.getAttribute('form')) ||
      ((document.querySelector('form[action*="/cart/add"]') || {}).id) ||
      'AddToCartForm-product-template';
  }

  function ensureHiddenProperty(root, className, propertyName, initialValue) {
    if (!root) return null;

    var field = root.querySelector && root.querySelector('.' + className);
    var isNew = !field;

    if (isNew) {
      field = document.createElement('input');
      field.type = 'hidden';
      field.className = className;
      field.name = 'properties[' + propertyName + ']';
      if (initialValue) field.value = initialValue;
    }

    field.setAttribute('form', getFormId(root));

    if (isNew) root.appendChild(field);
    return field;
  }

  function fitText() {
    if (!state.previewRoot || !state.textEl) return;

    var base = window.matchMedia('(max-width: 480px)').matches ? 38 : 56;
    var min = window.matchMedia('(max-width: 480px)').matches ? 22 : 30;

    state.textEl.style.fontSize = base + 'px';

    requestAnimationFrame(function(){
      var available = state.previewRoot.clientWidth - 36;
      var width = state.textEl.scrollWidth;

      if (width > available && width > 0) {
        state.textEl.style.fontSize = Math.max(min, Math.floor(base * available / width)) + 'px';
      }
    });
  }

  function addFontFaces(fonts) {
    var oldStyle = document.getElementById('stk-show-plate-font-faces');
    if (oldStyle) oldStyle.parentNode.removeChild(oldStyle);

    var styleEl = document.createElement('style');
    styleEl.id = 'stk-show-plate-font-faces';

    fonts.forEach(function(font, index){
      var family = font.family || (index === 0 ? 'stk-show-plate-licenz' : 'stk-show-plate-font-' + index);
      var formatMap = { ttf: 'truetype', otf: 'opentype', woff: 'woff', woff2: 'woff2' };
      var rawFormat = (font.format || 'truetype').toLowerCase();
      var format = formatMap[rawFormat] || rawFormat;
      var url = font.url || fontsBase + '/' + encodeURIComponent(String(font.file).normalize('NFKD').replace(/[^A-Za-z0-9._-]+/g, '_'));

      font.css = "'" + family + "', sans-serif";
      styleEl.appendChild(document.createTextNode(
        "@font-face{font-family:'" + family + "';src:url('" + url + "') format('" + format + "');font-display:swap;}"
      ));
    });

    document.head.appendChild(styleEl);
  }

  function refreshFontOptionLabels() {
    if (!state.fontList) return;

    var value = getPreviewValue();
    Array.prototype.forEach.call(state.fontList.children, function(item){
      setFontPreviewContent(item, value, item.getAttribute('data-name') || 'Licenz');
      item.setAttribute('title', item.getAttribute('data-name') || value);
    });
  }

  function update() {
    if (!state.input || !document.documentElement.contains(state.input)) {
      state.input = findPlateInput();
    }

    var value = getPreviewValue();

    if (state.textEl) {
      state.textEl.textContent = value;
      state.textEl.style.fontFamily = state.currentFont.css;
      fitText();
    }

    if (state.fontLabel) {
      setFontPreviewContent(state.fontLabel, value, state.currentFont.name);
      state.fontLabel.style.fontFamily = state.currentFont.css;
    }

    if (state.fontName) state.fontName.textContent = '(' + state.currentFont.name + ')';
    if (state.propFont) state.propFont.value = state.currentFont.name;
    if (state.propText && state.input) state.propText.value = state.input.value;

    refreshFontOptionLabels();
  }

  function bindInput() {
    state.input = findPlateInput();
    if (!state.input || state.input.dataset.stkShowPlateBound === 'true') return;

    state.input.dataset.stkShowPlateBound = 'true';
    state.input.addEventListener('input', update);
    state.input.addEventListener('change', update);
  }

  function buildFontList() {
    if (!state.fontList || !state.fonts.length) return;

    state.fontList.innerHTML = '';

    state.fonts.forEach(function(font, index){
      var item = document.createElement('li');
      item.setAttribute('role', 'option');
      item.setAttribute('data-name', font.name);
      item.setAttribute('data-css', font.css);
      setFontPreviewContent(item, getPreviewValue(), font.name);
      item.setAttribute('title', font.name);
      item.style.fontFamily = font.css;

      if (font.name === state.currentFont.name || index === 0) item.setAttribute('aria-selected', 'true');
      state.fontList.appendChild(item);
    });
  }

  function loadFonts() {
    if (state.fontsBuilt) return;
    state.fontsBuilt = true;

    window.stkFontIndexFetch(fontsIndexUrl)
      .then(function(response){ return response.ok ? response.json() : []; })
      .then(function(fonts){
        var usableFonts = [state.currentFont];

        if (Array.isArray(fonts)) {
          fonts.forEach(function(font){
            if (!font || !font.name) return;
            if (/^licenz$/i.test(font.name)) return;
            usableFonts.push(font);
          });
        }

        state.fonts = usableFonts;
        addFontFaces(state.fonts);
        buildFontList();
        update();
      })
      .catch(function(){
        state.fonts = [state.currentFont];
        addFontFaces(state.fonts);
        buildFontList();
        update();
      });
  }

  function initFontControls(root) {
    if (!root || root.dataset.stkShowPlateFontReady === 'true') return;

    state.fontRoot = root;
    state.fontButton = root.querySelector('.stk-show-plate-font-button');
    state.fontLabel = root.querySelector('.stk-show-plate-font-label');
    state.fontList = root.querySelector('.stk-show-plate-font-list');
    state.fontName = root.querySelector('.stk-show-plate-font-name');
    state.propFont = ensureHiddenProperty(root, 'stk-show-plate-prop-font', 'Font', state.currentFont.name);

    if (state.fontButton && state.fontList) {
      state.fontButton.addEventListener('click', function(){
        refreshFontOptionLabels();
        state.fontList.hidden = !state.fontList.hidden;
        state.fontButton.setAttribute('aria-expanded', state.fontList.hidden ? 'false' : 'true');
      });

      state.fontList.addEventListener('click', function(event){
        var item = event.target.closest('li');
        if (!item) return;

        Array.prototype.forEach.call(state.fontList.children, function(child){
          child.removeAttribute('aria-selected');
        });

        item.setAttribute('aria-selected', 'true');
        state.currentFont = {
          name: item.getAttribute('data-name'),
          css: item.getAttribute('data-css')
        };

        state.fontList.hidden = true;
        state.fontButton.setAttribute('aria-expanded', 'false');
        update();
      });

      document.addEventListener('click', function(event){
        if (!root.contains(event.target)) {
          state.fontList.hidden = true;
          state.fontButton.setAttribute('aria-expanded', 'false');
        }
      });
    }

    root.dataset.stkShowPlateFontReady = 'true';
    buildFontList();
    update();
  }

  function initPreview(root) {
    if (!root || root.dataset.stkShowPlateReady === 'true') return;

    state.previewRoot = root;
    state.textEl = root.querySelector('[data-stk-show-plate-text]');
    state.propText = ensureHiddenProperty(root, 'stk-show-plate-prop-text', 'Plate Text', '');

    var builtInFontControls = root.querySelector('.stk-show-plate-font-button') ? root : null;
    if (builtInFontControls) initFontControls(builtInFontControls);

    root.dataset.stkShowPlateReady = 'true';
    update();
  }

  function initAll(context) {
    var scope = context || document;

    bindInput();

    scope.querySelectorAll('[data-stk-show-plate-preview], .stk-show-plate-preview').forEach(initPreview);
    scope.querySelectorAll('[data-stk-show-plate-font], .stk-show-plate-font-control').forEach(initFontControls);

    loadFonts();
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function(event){
    initAll(event.target);
  });

  window.addEventListener('resize', update);

  var tries = 0;
  var retry = setInterval(function(){
    tries += 1;
    initAll(document);

    if ((document.querySelector('[data-stk-show-plate-preview], .stk-show-plate-preview') &&
        document.querySelector('[data-stk-show-plate-font], .stk-show-plate-font-control')) || tries >= 12) {
      clearInterval(retry);
    }
  }, 500);
})();
